

export default {
name: 'afterSalesTerms',
components: {

},
data () {
return {

}
},
methods: {

},
created () {

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/afterSalesTerms/script.js